//----- Component --------------------------------------------------------/
// Developer :  Ignacio Bastianelli && Guillermo Sedran
// Creation Date :11/02/2025
// Version : 1.0
// Description : Creacion de solicitudes de trabajo para RRHH
//------Changes ----------------------------------------------------------//
// Change Date :
// Change by :
// Change description:
// Change Date :
// Change by :
// Change description:
//========================================================================/

import React, { useState, useMemo, useEffect } from "react";
import { MaterialReactTable } from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es"; //Tabla en español
import Navbar from "../../Navbar";
import AddBoxTwoToneIcon from "@mui/icons-material/AddBoxTwoTone";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import UpdatedUploadFiles from "../../../services/UpdatedUploadFiles";

import ChangeCircleIcon from "@mui/icons-material/ChangeCircle";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import PersonRemoveIcon from "@mui/icons-material/PersonRemove";

import EditNoteIcon from "@mui/icons-material/EditNote";
import GroupIcon from "@mui/icons-material/Group";
import {
  Button,
  Container,
  Alert,
  Box,
  Typography,
  ListItemIcon,
  MenuItem,
  Badge,
} from "@mui/material";
import { createTheme, ThemeProvider, useTheme } from "@mui/material";
import { getData } from "../../../services/library";
import SolicitudInfo from "./SolicitudInfo";
import SolicitudDePersonalForm from "./SolicitudDePersonalForm";
import SolicitudDePersonalDelete from "./SolicitudDePersonalDelete";

import Candidatos from "../candidatos/Candidatos";

import moment from "moment";
import { UrlApi } from "../../../services/apirest";
import TabSolicitudes from "./TabSolicitudes";
import MotivosModal from "../motivos/MotivosModal";
import { useNavigate } from "react-router-dom";
import InsertInvitationIcon from "@mui/icons-material/InsertInvitation";
import ModalCambioDeEstadoSolicitud from "./ModalCambioDeEstadoSolicitud";
import { logEventos } from "../../../services/services";

const SolicitudDePersonal = () => {
  const [nuevoEstadoSolicitud, setNuevoEstadoSolicitud] = useState(null);
  const [openCambioDeEstadoModal, setOpenCambioDeEstadoModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [rowInfo, setRowInfo] = useState({});
  const [puestos, setPuestos] = useState([]);
  const [mostrarAlerta, setMostrarAlerta] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("");
  const [openFormModal, setOpenFormModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [openCandidatosModal, setOpenCandidatosModal] = useState(false);
  const [rowInfoToDelete, setRowInfoToDelete] = useState({});
  const [idCandidato, setIdCandidato] = useState(-1);
  const [idSolicitud, setIdSolicitud] = useState(-1);
  //console.log("puestos",puestos)
  const handleToogleStateModal = () => {
    setOpenCambioDeEstadoModal(true);
  };
  //Estado para los tabs de arriba

  const navigate = useNavigate();

  const [tabIndex, setTabIndex] = useState(1);
  //console.log("tabIndex",tabIndex)
  // ADJUNTOS
  const [openModalAdj, setOpenModalAdj] = useState(false);
  const [newUuid, setNewUuid] = useState(""); //ADJUNTAR COMPROBANTE

  const [openModalMotivo, setOpenModalMotivo] = useState(false);

  // *** EL BARTO ESTUVO AQUÏ ***
  const [infoSolicitud, setInfoSolicitud] = useState({});
  // ****************************

  const rrhh = localStorage.getItem("adminrrhh");
  const user = localStorage.getItem("user");
  const sucursales = localStorage.getItem("suc_auth");
  const listaSucursales = sucursales.split(",").map(Number);
  const oculto = localStorage.getItem("solicitud_oculta");

  const traerSolicitudes = () => {
    if (rrhh === "1" && oculto === "1") {
      getData("/solicitudDePersonal/rrhhAdmin", setPuestos);
    } else if (rrhh === "1") {
      getData("/solicitudDePersonal", setPuestos);
    } else {
      fetch(`${UrlApi}/solicitudDePersonal/filtredByUser`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ sucursales: listaSucursales, user }),
      })
        .then((res) => res.json())
        .then((data) => setPuestos(data))
        .catch((err) => console.error("Error:", err));
    }
  };

  const handleOpenModalMotivo = (idCandidato, idSolicitud) => {
    setOpenModalMotivo(true);
    setIdCandidato(idCandidato);
    setIdSolicitud(idSolicitud);
  };

  useEffect(() => {
    traerSolicitudes();
  }, [openCandidatosModal]);

  const handleOpenCloseFormModal = () => {
    setOpenFormModal(!openFormModal);
  };

  const handleOpenCloseDeleteModal = () => {
    setOpenDeleteModal(!openDeleteModal);
  };

  const handleToogleModalAdj = async (uuid) => {
    setOpenModalAdj(!openModalAdj);
    setNewUuid(uuid);
  };

  // *** GUILLE ESTUVO AQUÍ ***
  const handleOpenCloseCandidatosModal = () => {
    setOpenCandidatosModal(!openCandidatosModal);
  };
  // **************************

  const mostrarAlertaTemporal = (mensaje, severidad) => {
    setMostrarAlerta(true);
    setMessage(mensaje);
    setSeverity(severidad);

    setTimeout(() => {
      setMostrarAlerta(false);
    }, 5000);
  };

  const initialState = {
    density: "compact",
    showGlobalFilter: true,
    pagination: { pageIndex: 0, pageSize: 10 },
  };

  const muiSearchTextFieldProps = {
    placeholder: "Buscar..",
    sx: { minWidth: "18rem", backgroundColor: "#ffffff" },
    variant: "outlined",
    color: "primary",
    size: "small",
  };

  const tableHeadCellProps = {
    align: "left",
    sx: {
      fontSize: 16,
      color: "white",
      fontWeight: "normal",
      backgroundColor: "#2471A3",
      borderColor: "black",
    },
  };
  // aprobado_parte_medico
  // aprobadoentrevista
  const columns = useMemo(() => {
    const baseColumns = [
      { header: "ID", accessorKey: "id", size: 10},
      { header: "Puesto", accessorKey: "puesto", size: 100 ,
        
      },
      { header: "Prioridad", accessorKey: "prioridad_value", size:60 },
       {
        header: "Fecha de solicitud",
        accessorFn: (row) => moment(row.fecha_solicitud).format("DD/MM/YYYY"),
        size: 80,
      },
      {
        header: "Solicitado por",
        accessorKey: "apellido_creador",
        size: 70,
      },
      { header: "Sucursal", accessorKey: "sucursal", size: 80 },
      // {
      //   header: "Fecha de solicitud",
      //   accessorFn: (row) => moment(row.fecha_solicitud).format("DD/MM/YYYY"),
      //   size: 90,
      // },
      {
        header: "Candidatos",
        accessorFn: (row) => (row.cantidad_candidatos > 0 ? "SI" : "NO"),
        size: 60,
      },
    ];

    return baseColumns;
  }, []);

  const globalTheme = useTheme();
  const tableTheme = useMemo(
    () =>
      createTheme({
        palette: {
          mode: globalTheme.palette.mode,
          primary: globalTheme.palette.primary,
          info: {
            main: "rgb(255,122,0)",
          },
          background: {
            default:
              globalTheme.palette.mode === "light"
                ? "rgb(234, 239, 241)"
                : "#000",
          },
        },
        typography: {
          button: {
            textTransform: "none",
            fontSize: "1rem",
          },
        },
        components: {
          MuiTooltip: {
            styleOverrides: {
              tooltip: {
                fontSize: "0.8rem",
              },
            },
          },
        },
      }),
    [globalTheme]
  );

  let filtredPuestos;

  // if (tabIndex === 3)
  //   filtredPuestos = puestos.filter((puesto) => {
  //     if (rrhh === "1") {
  //       return puesto.activa === null;
  //     } else {
  //       return (
  //         puesto.activa === null && puesto.creador_de_la_solicitud === user
  //       );
  //     }
  //   });
  // else filtredPuestos = puestos.filter((puesto) => puesto.activa === tabIndex);
  // Orden descendente por ID

  //   if (tabIndex === 3) { //3 es sin autorizar
  //   filtredPuestos = puestos
  //     .filter((puesto) => {
  //       if (rrhh === "1") {
  //         return puesto.activa === null;
  //       } else {
  //         return (
  //           puesto.activa === null && puesto.creador_de_la_solicitud === user
  //         );
  //       }
  //     })
  //     .sort((a, b) => b.id - a.id); // Orden descendente por ID

  // } else if (tabIndex === 4) {  //guillea para tarea tab doc  pendiente revisar
  //   filtredPuestos = puestos
  //     .filter((puesto) => {
  //       console.log('Revisando puesto aprobado:', puesto.id, 'activa:', puesto.activa);
  //       return puesto.activa === 2;
  //     })
  //     .sort((a, b) => b.id - a.id);
  // }else {
  //   filtredPuestos = puestos
  //     .filter((puesto) => puesto.activa === tabIndex)
  //     .sort((a, b) => b.id - a.id);
  // }
//
  // if (tabIndex === 4) {
  //   // Sin autorizar
  //   filtredPuestos = puestos
  //     .filter((puesto) => {
  //       if (rrhh === "1") {
  //         return puesto.activa === null;
  //       } else {
  //         return (
  //           puesto.activa === null && puesto.creador_de_la_solicitud === user
  //         );
  //       }
  //     })
  //     .sort((a, b) => b.id - a.id);
  // } else if (tabIndex === 3) {
  //   // Aprobadas
  //   filtredPuestos = puestos
  //     .filter((puesto) => puesto.activa === 2)
  //     .sort((a, b) => b.id - a.id);
  // } else if (tabIndex === 2) {
  //   // Preselección
  //   filtredPuestos = puestos
  //     .filter((puesto) => puesto.activa === 3)
  //     .sort((a, b) => b.id - a.id);
  //   // .filter((p) =>
  //   //   (
  //   //     (p.legajo && p.legajo !== "") ||
  //   //     (p.fechaingreso && p.fechaingreso !== "")
  //   //   ) &&
  //   //   p.activa !== 2
  //   // )
  //   // .sort((a, b) => b.id - a.id);
  // } else {
  //   // Desactivadas (0) y Pendientes (1)   aprobadas (2) sin autonizar null preseleccion 3 solo se usa para mostrar los preselecionados
  //   filtredPuestos = puestos
  //     .filter((puesto) => puesto.activa === tabIndex)
  //     .sort((a, b) => b.id - a.id);
  // }

  //nuevo 
  if (tabIndex === 4) {
    // Sin autorizar
    filtredPuestos = puestos
      .filter((puesto) => {
        if (rrhh === "1") {
          return puesto.activa === null;
        } else {
          return (
            puesto.activa === null && puesto.creador_de_la_solicitud === user
          );
        }
      })
      .sort((a, b) => b.id - a.id);
  } else if (tabIndex === 3) {
    // Aprobadas
    filtredPuestos = puestos
      .filter((puesto) => puesto.activa === 2)
      .sort((a, b) => b.id - a.id);
  } else if (tabIndex === 2) {
    // Preselección
    filtredPuestos = puestos
      .filter((puesto) => puesto.activa === 3)
      .sort((a, b) => b.id - a.id);
    // .filter((p) =>
    //   (
    //     (p.legajo && p.legajo !== "") ||
    //     (p.fechaingreso && p.fechaingreso !== "")
    //   ) &&
    //   p.activa !== 2
    // )
    // .sort((a, b) => b.id - a.id);
  } else if (tabIndex === 5) {
     // ver solicitudes ocultas
  if (rrhh === "1" && oculto === "1") {
   //  console.log("Entró en condición rrhh=1 y oculto=1");
    filtredPuestos = puestos
      .filter((puesto) => puesto.oculto === 1) 
      .sort((a, b) => b.id - a.id);
        // console.log("Puestos filtrados en oculto:", filtredPuestos);
  } else {
 filtredPuestos = []; // No muestra nada si no esta autorizado en user prod localstorague solicitud_oculta === 1
}
    
  }
  
  
  
  
  else {
    // Desactivadas (0) y Pendientes (1)   aprobadas (2) sin autonizar null preseleccion 3 solo se usa para mostrar los preselecionados
    filtredPuestos = puestos
      .filter((puesto) => puesto.activa === tabIndex)
      .sort((a, b) => b.id - a.id);
  }

  //guillea tarea completars los de eventos
  useEffect(() => {
    logEventos(
      "acceso al menu solicitud personal",
      "rrhh Solicitudes",
      "Lista tabs Solicitudes",
      localStorage.getItem("user")
    );
  }, []);

  return (
    <>
      {openCambioDeEstadoModal && (
        <ModalCambioDeEstadoSolicitud
          idSolicitud={idSolicitud}
          obtenerSolicitudes={traerSolicitudes}
          onClose={() => setOpenCambioDeEstadoModal(false)}
          open={openCambioDeEstadoModal}
          nuevoEstado={nuevoEstadoSolicitud}
          mostrarAlertaTemporal={mostrarAlertaTemporal}
        />
      )}
      {openModalMotivo && (
        <MotivosModal
          open={openModalMotivo}
          onClose={() => setOpenModalMotivo(false)}
          id_candidato={idCandidato}
          mostrarAlertaTemporal={mostrarAlertaTemporal}
          obtenerSolicitudes={traerSolicitudes}
          id_solicitud={idSolicitud}
        />
      )}
      {openModalAdj && ( // ADJUNTAR
        <UpdatedUploadFiles
          fileId={newUuid}
          open={openModalAdj}
          setOpen={setOpenModalAdj}
          readOnly={false}
          onClose={() => setOpenModalAdj(false)} // Proporciona una función de cierre
        />
        /*
        <UploadFiles fileId={newUuid} openclose={setOpenModalAdj} />
      */
      )}
      {openFormModal && (
        <SolicitudDePersonalForm
          isEditMode={isEditMode}
          rowInfo={isEditMode ? rowInfo : {}}
          handleOpenCloseModalForm={handleOpenCloseFormModal}
          obtenerSolicitudes={traerSolicitudes}
          mostrarAlertaTemporal={mostrarAlertaTemporal}
        />
      )}
      {openDeleteModal && (
        <SolicitudDePersonalDelete
          rowInfo={rowInfoToDelete}
          setOpen={setOpenDeleteModal}
          open={openDeleteModal}
          getSolicitud={traerSolicitudes}
          mostrarAlerta={mostrarAlertaTemporal}
        />
      )}
      {openCandidatosModal && (
        <Candidatos
          rowInfo={infoSolicitud}
          setOpen={setOpenCandidatosModal}
          open={openCandidatosModal}
        />
      )}
      {mostrarAlerta && (
        <Alert
          severity={severity}
          sx={{
            zIndex: 1600,
            position: "fixed",
            top: "20px",
            right: "20px",
            width: "auto",
            borderRadius: "8px",
            backgroundColor:
              severity === "success"
                ? "#d8e6d3"
                : severity === "error"
                ? "#efc3c3"
                : severity === "warning"
                ? "#f0efb6"
                : severity === "info"
                ? "#0a8ff5"
                : "#e6e6e6",
          }}
        >
          {message}
        </Alert>
      )}
      <Navbar />
      <TabSolicitudes value={tabIndex} setValue={setTabIndex} />
      <Container maxWidth={false} sx={{ width: "100%" }} mt={1}>
        {puestos ? (
          <Box mt={2} mb={4}>
            <ThemeProvider theme={tableTheme}>
              <MaterialReactTable
                enableToolbarInternalActions={true}
                autoResetPageIndex={false}
                enableGrouping
                layoutMode="grid"
                muiTableHeadCellProps={tableHeadCellProps}
                muiTableBodyCellProps={({ row }) => ({
                  align: "justify",
                  sx: {
                    padding: "6px 0px", // Reduce el padding para hacerla más compacta
                    borderColor: "black",
                    // backgroundColor:
                    //      tabIndex === 4 && row.original.activa === 2   //guillea para tarea tab doc  pendiente abrazo revisar
                    //     ? "#FFD9B3" :
                    backgroundColor:
                      tabIndex === 2 && row.original.activa === 3
                        ? "#FFD9B3"
                        : row.original.activa === 2
                        ? "#b3e6b3"
                        : row.original.activa === 0
                        ? "#efc3c3"
                        : row.original.notificacion_medica === 0 && rrhh === "1"
                        ? "#d6d6d6"
                        : "#fff",
                    wordWrap: "break-word",
                    whiteSpace: "nowrap", // Evita que el ID se expanda demasiado
                  },
                })}
                enableColumnActions={true}
                enableColumnFilters={false}
                enableHiding={false}
                enableDensityToggle={false}
                localization={MRT_Localization_ES}
                enableColumnDragging={false}
                initialState={initialState}
                renderDetailPanel={({ row }) => (
                  <Container
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      margin: "auto",
                      width: "1200px",
                    }}
                  >
                    <SolicitudInfo rowData={row.original} />
                  </Container>
                )}
                muiSearchTextFieldProps={muiSearchTextFieldProps}
                columns={columns}
                data={filtredPuestos}
                enableStickyFooter
                enableRowActions
                positionActionsColumn="last"
                renderToolbarInternalActions={({ table }) => <></>}
                renderTopToolbarCustomActions={() => (
                  <Box sx={{ display: "flex" }}>
                    <Box
                      sx={{
                        marginRight: 2,
                        display: "flex",
                        gap: 4,
                      }}
                    >
                      <Typography
                        variant="poster"
                        style={{ fontSize: 26, textAlign: "center" }}
                      >
                        Solicitudes
                      </Typography>
                      <Button
                        variant="contained"
                        color="success"
                        startIcon={<AddBoxTwoToneIcon color="asd" />}
                        aria-haspopup="true"
                        onClick={() => {
                          setIsEditMode(false);
                          handleOpenCloseFormModal();
                        }}
                      >
                        Añadir solicitud de personal
                      </Button>
                      <Button
                        variant="contained"
                        startIcon={<InsertInvitationIcon color="asd" />}
                        sx={{
                          backgroundColor: "#368dff",
                          "&:hover": {
                            backgroundColor: "#006eff",
                          },
                        }}
                        onClick={() => navigate("/SP_proximas_entrevistas")}
                      >
                        Agenda de entrevistas
                      </Button>
                    </Box>
                  </Box>
                )}
                renderRowActionMenuItems={({ closeMenu, row }) => {
                  const menuItems = [];

                  const puedeEditar =
                    rrhh === "1" ||
                    user === row.original.creador_de_la_solicitud;

                  if (row.original.activa === null) {
                    if (rrhh === "1") {
                      menuItems.push(
                        <MenuItem
                          key="rechazar"
                          onClick={() => {
                            setIdSolicitud(row.original.id);
                            setNuevoEstadoSolicitud(null);
                            closeMenu();
                            handleToogleStateModal();
                          }}
                        >
                          <ListItemIcon>
                            <PersonRemoveIcon sx={{ color: "red" }} />
                          </ListItemIcon>
                          Rechazar solicitud
                        </MenuItem>,
                        <MenuItem
                          key="autorizar"
                          onClick={() => {
                            setIdSolicitud(row.original.id);
                            setNuevoEstadoSolicitud(1);
                            closeMenu();
                            handleToogleStateModal();
                          }}
                        >
                          <ListItemIcon>
                            <PersonAddIcon sx={{ color: "green" }} />
                          </ListItemIcon>
                          Autorizar solicitud
                        </MenuItem>
                      );
                    }

                    if (puedeEditar) {
                      menuItems.push(
                        <MenuItem
                          key="editar"
                          onClick={() => {
                            setIsEditMode(true);
                            setRowInfo(row.original);
                            closeMenu();
                            handleOpenCloseFormModal();
                          }}
                        >
                          <ListItemIcon>
                            <EditNoteIcon sx={{ color: "skyblue" }} />
                          </ListItemIcon>
                          Editar
                        </MenuItem>,
                        <MenuItem
                          key="eliminar"
                          onClick={() => {
                            setIdSolicitud(row.original.id);
                            setNuevoEstadoSolicitud(null);
                            closeMenu();
                            handleToogleStateModal();
                          }}
                        >
                          <ListItemIcon>
                            <EditNoteIcon sx={{ color: "red" }} />
                          </ListItemIcon>
                          Eliminar solicitud
                        </MenuItem>
                      );
                    }

                    return menuItems;
                  }

                  // Para solicitudes con activa !== null
                  if (puedeEditar) {
                    menuItems.push(
                      <MenuItem
                        key="editar"
                        onClick={() => {
                          setIsEditMode(true);
                          setRowInfo(row.original);
                          closeMenu();
                          handleOpenCloseFormModal();
                        }}
                      >
                        <ListItemIcon>
                          <EditNoteIcon sx={{ color: "skyblue" }} />
                        </ListItemIcon>
                        Editar
                      </MenuItem>
                    );
                  }

                  if (
                    row.original.activa !== 2 &&
                    puedeEditar &&
                    !(row.original.activa === 3 && rrhh === "1")
                  ) {
                    menuItems.push(
                      <MenuItem
                        key="toggle"
                        onClick={() => {
                          handleOpenCloseDeleteModal();
                          setRowInfoToDelete({
                            id: row.original.id,
                            activa: row.original.activa,
                          });
                          closeMenu();
                        }}
                      >
                        <ListItemIcon>
                          {row.original.activa === 1 ? (
                            <HighlightOffIcon color="error" />
                          ) : (
                            <CheckCircleIcon color="success" />
                          )}
                        </ListItemIcon>
                        {row.original.activa === 1
                          ? "Desactivar solicitud"
                          : "Activar solicitud"}
                      </MenuItem>
                    );
                  }

                  menuItems.push(
                    <MenuItem
                      key="adjunto"
                      onClick={() => {
                        handleToogleModalAdj(row.original.uuid);
                        closeMenu();
                      }}
                    >
                      <ListItemIcon>
                        <PictureAsPdfIcon sx={{ color: "orange" }} />
                      </ListItemIcon>
                      Agregar archivo
                    </MenuItem>
                  );

                  if (
                    (row.original.id_candidato_seleccionado !== null &&
                      rrhh === "1") ||
                    (row.original.activa === 3 && rrhh === "1")
                  ) {
                    menuItems.push(
                      <MenuItem
                        key="rechazada"
                        onClick={() => {
                          handleOpenModalMotivo(
                            row.original.id_candidato_seleccionado,
                            row.original.id
                          );
                          closeMenu();
                        }}
                      >
                        <ListItemIcon>
                          <PersonRemoveIcon color="error" />
                        </ListItemIcon>
                        Propuesta rechazada
                      </MenuItem>
                    );
                  }

                  menuItems.push(
                    <Badge
                      key="candidatos"
                      color="secondary"
                      badgeContent={row.original.cantidad_candidatos ?? 0}
                      showZero
                      sx={{
                        "& .MuiBadge-badge": {
                          background: "green",
                          color: "white",
                          fontSize: "0.75rem",
                          minWidth: "17px",
                          height: "17px",
                          top: "4px",
                          padding: "0 3px",
                          right: "10px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        },
                      }}
                    >
                      <MenuItem
                        onClick={() => {
                          handleOpenCloseCandidatosModal();
                          setInfoSolicitud(row.original);
                          closeMenu();
                        }}
                      >
                        <ListItemIcon>
                          <GroupIcon color="primary" />
                        </ListItemIcon>
                        Ver Candidatos
                      </MenuItem>
                    </Badge>
                  );

                  return menuItems;
                }}
              />
            </ThemeProvider>
          </Box>
        ) : null}
      </Container>
    </>
  );
};

export default SolicitudDePersonal;
